import { put, call, all, takeLatest } from 'redux-saga/effects'
import { ACTION_TYPES } from 'store/reducers/notifications'
import { ACTION_TYPES as NOTIFICATION_TYPES } from 'store/reducers/notification'
import { REQUEST_ERROR } from 'config/messages'
import {
  getNotifications as getNotificationsService,
  putNotifications as putNotificationsServices
} from 'services'

const {
  NOTIFICATIONS_REQUEST,
  NOTIFICATIONS_SUCCESS,
  NOTIFICATIONS_ERROR,
  NOTIFICATIONS_UPDATE,
  NOTIFICATIONS_UPDATE_SUCCESS
} = ACTION_TYPES


export function *getNotificationsSaga() {
  try {
    const { data: { notifications } } = yield call(getNotificationsService)
    yield put({
      type: NOTIFICATIONS_SUCCESS,
      payload: notifications
    })
  } catch (err) {
    yield put({ type: NOTIFICATIONS_ERROR })
  }
}

export function *updateNotificationsSaga(payload) {
  try {
    yield call(putNotificationsServices, payload)
    yield put({ type: NOTIFICATIONS_UPDATE_SUCCESS })
    yield put({
      type: NOTIFICATION_TYPES.SHOW_NOTIFICATION,
      payload: { text: 'Notificações cadastradas com sucesso!', type: 'success' }
    })
  } catch (error) {
    yield put({ type: NOTIFICATIONS_ERROR })
    yield put({
      type: NOTIFICATION_TYPES.SHOW_NOTIFICATION,
      payload: { text: REQUEST_ERROR.SERVER_ERROR.TITLE, type: 'error' }
    })
  }
}

export default function *watchNotifications() {
  yield all([
    takeLatest(NOTIFICATIONS_REQUEST, getNotificationsSaga),
    takeLatest(NOTIFICATIONS_UPDATE, updateNotificationsSaga)
  ])
}
